import { Box, Button, Divider, Grid, IconButton, LinearProgress, TextField, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserAuth } from "../../../store/context/userContext";
import { useEffect, useState } from "react";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import MultiSelectCheckboxes from "../../formElement/MultiSelectCheckBoxes";
import config from "../../../config";
import { CommonContext } from "../../../store/context/commonContext";
import GreyLabel from "../../../commonComponents/formElement/GreyLabel";
import LoaderButton from "../../LoaderButton";
import * as Icon from "@mui/icons-material";
import { DEFAULT_LOGO_SIZE, SMALL_LOGO_SIZE } from "../../CommonConstants/commonKeys";
import AuthImage from "../AuthImage";
import GoogleAuth from "../googleSignInUp";


const getCharacterValidationError = (str) => {
    return `Your password must have at least 1 ${str} character`;
};
const validationSchema = Yup.object().shape({
    fname: Yup.string().required('First name is required').max(50, "Maximum 50 characters allowed."),
    lname: Yup.string().required('Last name is required').max(50, "Maximum 50 characters allowed."),
    email: Yup.string().required('Email required').email('Invalid email').matches(/@[^.]*\./, 'Invalid email'),
    passwd: Yup.string()
        .required("Please enter a password")
        // check minimum characters
        .min(8, "Password must have at least 8 characters")
        // different error messages for different requirements
        .matches(/[0-9]/, getCharacterValidationError("digit"))
        .matches(/[a-z]/, getCharacterValidationError("lowercase"))
        .matches(/[A-Z]/, getCharacterValidationError("uppercase")),
    phone: Yup.string()
        .matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, {
            message: "Phone number is not valid",
            excludeEmptyString: true
        }),
    user_interest: Yup.array()
        .transform(ids => {
            if (Array.isArray(ids)) {
                return ids.filter(id => {
                    return id === 0 || id;
                });
            }
            else {
                ids = (ids === false) ? [] : [ids];
                return ids;
            }
        })
});

const SignUp = ({ handleOpen, handleClose }) => {
    let { authPopup, setAuthPopup, user } = UserAuth()
    const navigate = useNavigate()
    const location = useLocation()
    const closePopup = () => {
        setAuthPopup({ ...authPopup, open: false })
        if (
            !(location.pathname.includes('/search') ||
                location.pathname.includes('/package') ||
                location.pathname.includes('/property') ||
                location.pathname.includes('/aboutus') ||
                location.pathname.includes('/contactus'))
        ) {
            if (!user) {
                navigate('/')
            }
        }
    }

    const [formData, setFormData] = useState({
        fname: '',
        lname: '',
        email: '',
        passwd: '',
        phone: '',
        user_interest: [config.module === 'lister' ? 'Landowner' : 'Guest']
    });
    let { registerUser, loginUserWithThirdPartyApp } = UserAuth()
    const [loading, setLoading] = useState(false)
    const { isMobile, isNineHundred, screenWidth, isTablet } = CommonContext();

    const handleRegister = (data) => {
        setLoading(true);

        // Convert user_interest array to JSON string
        const jsonProfileType = JSON.stringify(formData.user_interest.map(item => item === 'Landowner' ? 'L' : (item === 'Guest' ? 'G' : item)));

        // Update the form data with the modified user_interest
        const updatedFormData = { ...formData, user_interest: jsonProfileType };

        registerUser(updatedFormData, () => {
            handleClose();
        }, () => {
            setLoading(false);
        });
    }

    const handleSelect = (value) => {
        setFormData({ ...formData, user_interest: value })
    }

    const onInput = (e) => {
        let temp = {}
        temp[e.target.name] = e.target.value
        setFormData({ ...formData, ...temp })
    }

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {}
    });

    const handleGoogleSuccess = async ({ idToken, profileObj }) => {
        setLoading(true)
        // console.log("Recieved accessToken from gooogle :- ", idToken);
        // console.log("profileObj :- ", profileObj);
        loginUserWithThirdPartyApp(idToken, () => {
            // console.log("successfull call");
            handleClose()
        }, () => {
            handleClose()
            // console.log("failed call");
            setLoading(false)
        })
    };

    return (
        <>
            {<Box sx={{ float: "right", m: 1, position: 'absolute', top: 0, right: 0, "& .MuiButtonBase-root": { bgcolor: '#f1f1f1' } }}>
                <IconButton sx={{}} onClick={closePopup}><Icon.Close /></IconButton>
            </Box>}
            <Grid container maxWidth="lg" sx={{ color: 'var(--grey900)', overflow: 'hidden', }}
                direction="row"
                justifyContent="center"
                flexWrap={'nowrap'}
                alignItems="stretch">
                {!isNineHundred && <AuthImage />}
                <Grid item xs={12} sm={8} md={6} sx={{
                    ml: !isNineHundred && 'auto', py: 6, overflow: 'auto', maxWidth: isNineHundred && '100% !important', flexBasis: isNineHundred && '100% !important', width: isNineHundred && '100% !important', px: { xs: 0, sm: 3, md: 0 }
                }}>
                    {/* {loading && <LinearProgress color="success" />} */}
                    {/* {<Box sx={{ float: "right", m: 1, }}>
                        <IconButton onClick={closePopup}><Icon.Close /></IconButton>
                    </Box>} */}
                    <Box sx={{ px: isNineHundred ? 2 : 6 }}>
                        <Box sx={{ mb: 3 }}>
                            <img style={{ ... (isTablet ? SMALL_LOGO_SIZE : DEFAULT_LOGO_SIZE) }} src='../assets/images/farwide-new-logo.svg' alt='FarWide' />
                        </Box>

                        <Typography variant="h4" color="secondary" sx={{ fontWeight: 700, mb: 1 }}>Create New Account</Typography>
                        <Typography sx={{ mb: 3, color: 'var(--grey900)' }}>Already a member? <Link onClick={() => handleOpen("signin")} color='secondary' >Sign In</Link></Typography>

                        {/* <Grid container spacing={2} sx={{ mb: 3, mt: 1 }}>
                        <Grid ite m>
                            <Button variant="contained" color="grey300" size="large"
                                style={{ textTransform: "none" }}
                                startIcon={<img src="/lister/assets/images/login/fb_color_icon.svg" alt="" />}>
                                Sign Up with Facebook
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button variant="contained" color="grey300" size="large"
                                style={{ textTransform: "none" }}
                                startIcon={<img src="/lister/assets/images/login/google_color_icon.svg" alt="" />}>
                                Sign Up with Google
                            </Button>
                        </Grid>

                    </Grid>
                    <div className="linethrough"><span>or sign up with your email </span></div> */}
                        <GoogleAuth
                            onSuccess={handleGoogleSuccess}
                            buttonText="Sign Up with Google"
                            variant="contained"
                        />
                        <Box sx={{ paddingBlock: 3.5 }}>
                            <Divider><Typography variant="button" sx={{ color: '#747579', fontWeight: '400', textTransform: 'unset' }}>or Sign up with Email</Typography></Divider>
                            {/* <Box
                                sx={{ display: 'flex', flexDirection: 'column' }}
                            >
                                <Typography variant="button" sx={{ color: '#747579', fontWeight: '400', textTransform: 'unset' }}>or</Typography> <Typography variant="button" sx={{ color: '#747579', fontWeight: '400', textTransform: 'unset' }}>Sign up with Email</Typography>
                            </Box> */}
                        </Box>

                        <Grid container spacing={3}>

                            <Grid item xs={12} sm={6} md={6}>
                                <GreyLabel label={'First Name'} required />
                                <TextField
                                    fullWidth
                                    name="fname"
                                    sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                    label=""
                                    variant="outlined"
                                    value={formData.fname}
                                    onInput={onInput}
                                    {...register("fname")}
                                    error={errors.fname ? true : false}
                                    helperText={errors.fname?.message}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <GreyLabel label={'Last Name'} required />
                                <TextField
                                    fullWidth
                                    name="lname"
                                    sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                    label=""
                                    variant="outlined"
                                    value={formData.lname}
                                    onInput={onInput}
                                    {...register("lname")}
                                    error={errors.lname ? true : false}
                                    helperText={errors.lname?.message}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <GreyLabel label={'Email'} required />
                                <TextField
                                    fullWidth
                                    name="email"
                                    sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                    label=""
                                    type={"email"}
                                    variant="outlined"
                                    value={formData.email}
                                    onInput={onInput}
                                    {...register("email")}
                                    error={errors.email ? true : false}
                                    helperText={errors.email?.message}
                                    autoComplete="off"  // Disable autocomplete
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                                <GreyLabel label={'Password'} required />
                                <TextField
                                    fullWidth
                                    name="passwd"
                                    sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                    label=""
                                    type={"password"}
                                    variant="outlined"
                                    value={formData.passwd}
                                    onInput={onInput}
                                    {...register("passwd")}
                                    error={errors.passwd ? true : false}
                                    helperText={errors.passwd?.message}
                                    autoComplete="new-password"  // Disable autofill specifically for password
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <Typography sx={{ color: 'var(--grey900)', mb: 1 }} >Phone Number</Typography>
                                <TextField
                                    fullWidth
                                    name="phone"
                                    sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                    label=""
                                    variant="outlined"
                                    value={formData.phone}
                                    onInput={onInput}
                                    {...register("phone")}
                                    error={errors.phone ? true : false}
                                    helperText={errors.phone?.message}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{ mb: 1 }}>
                                <Typography sx={{ color: 'var(--grey900)', mb: 1 }}>How do you plan to use FarWide Experience?</Typography>
                                <Box className="bordered_wrapper">
                                    <MultiSelectCheckboxes
                                        handleSelect={handleSelect}
                                        name={"user_interest"}
                                        sx={{ "& .MuiOutlinedInput-root": { height: '42px' } }}
                                        itemList={['Guest', 'Landowner']}
                                        selectedItems={formData.user_interest}
                                        register={register}
                                        error={errors.user_interest ? true : false}
                                        helperText={errors.user_interest?.message}
                                        module={config.module}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} sx={{ mb: 6 }}>
                                {/* <Button fullWidth variant='contained' onClick={() => { handleSubmit(handleRegister)() }}>
                                Sign Up
                            </Button> */}
                                <LoaderButton
                                    variantType='contained'
                                    onClick={() => { handleSubmit(handleRegister)() }}
                                    isLoading={loading}
                                    buttonText="Sign Up"
                                    isFullWidth={true}
                                />
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="caption">By creating your account, you agree to accept our <Link to="https://search.farwide.com/privacy-terms" color='secondary' target={isMobile ? "" : "_blank"} >terms and conditions.</Link></Typography>
                                </Box>

                            </Grid>
                        </Grid>
                    </Box>


                </Grid>
            </Grid>
        </>
    )
}
export default SignUp